import {
  any, string, number,
} from '@sda/sdk/helpers/types.bitmasks';

export const PublicPendingProfileMask = {
  createdAt: any,
  updatedAt: any,
  collaborators: any,
  fullName: string,
  owner: string,
  numReviews: number,
  profileType: string,
  score: number,
};
